import type { SxProps, Theme } from '@mui/material/styles';

/** Cancels the top gutter MUI Grid `spacing` adds to an item, for rows that sit flush under the previous one. */
export const noTopGutterSx: SxProps<Theme> = { paddingTop: '0 !important' };
